export const topicOptions = [
  {
    value: 'GIFTS_MARKETING',
    label: 'Gifts/marketing',
    category: 'Marketing topics',
  },
  {
    value: 'PUBLICATIONS',
    label: 'Publications',
    category: 'Marketing topics',
  },
  {
    value: 'EVENTS',
    label: 'Events',
    category: 'Social topics',
  },
  {
    value: 'SOCIALIZING',
    label: 'Socializing',
    category: 'Social topics',
  },
  {
    value: 'BUSINESS_TRAVEL',
    label: 'Business travel',
    category: 'Social topics',
  },
  {
    value: 'ACQUISITION',
    label: 'Acquisition',
    category: 'Prospects & acquisition',
  },
  {
    value: 'INITIAL_CLIENT_CONTACT',
    label: 'Initial client contact',
    category: 'Prospects & acquisition',
  },
  {
    value: 'GENERAL_INFORMATION',
    label: 'General information',
    category: 'Prospects & acquisition',
  },
  {
    value: 'CLIENT_RESTRICTIONS',
    label: 'Client restrictions',
    category: 'Client onboarding & risk administration',
  },
  {
    value: 'KYC_INFORMATION_DISCUSSION',
    label: 'KYC information/discussion',
    category: 'Client onboarding & risk administration',
  },
  {
    value: 'TRANSACTION_MONITORING_CLARIFICATION',
    label: 'Transaction monitoring clarification',
    category: 'Client onboarding & risk administration',
  },
  {
    value: 'DATA_CONSENT',
    label: 'Data consent',
    category: 'Client onboarding & risk administration',
  },
  {
    value: 'RISK_DISCLOSURE',
    label: 'Risk disclosure',
    category: 'Client onboarding & risk administration',
  },
  {
    value: 'RESULT_MC_SPECIAL_PATTERN',
    label: 'Result MC special pattern',
    category: 'Client onboarding & risk administration',
  },
  {
    value: 'BANK_DOCUMENTS',
    label: 'Bank documents',
    category: 'Client onboarding & risk administration',
  },
  {
    value: 'OTHER',
    label: 'Other (please specify in notes)',
    category: 'Other',
  },
  {
    value: 'CREDIT',
    label: 'Credit',
    category: 'Credit facilities',
  },
  {
    value: 'PORTFOLIO_ANALYSIS_REPORT_DELIVERED',
    label: 'Portfolio analysis report delivered',
    category: 'Investment topics',
  },
  {
    value: 'COMPLAINT',
    label: 'Complaint',
    category: 'Complaint',
  },
  {
    value: 'INSTRUCTIONS',
    label: 'Instructions',
    category: 'Investment topics',
  },
  {
    value: 'INVESTMENT_ADVISORY_SERVICES',
    label: 'Investment advisory services',
    category: 'Investment topics',
  },
  {
    value: 'INVESTMENT_PROFILE',
    label: 'Investment profile',
    category: 'Investment topics',
  },
  {
    value: 'INVESTMENT_PROPOSAL',
    label: 'Investment proposal',
    category: 'Investment topics',
  },
  {
    value: 'PORTFOLIO_REVIEW',
    label: 'Portfolio review',
    category: 'Investment topics',
  },
  {
    value: 'PRICING_AND_FEES',
    label: 'Pricing & fees',
    category: 'Client & account maintenance',
  },
  {
    value: 'WEALTH_PLANNING_SUCCESSION_PLANNING',
    label: 'Wealth planning succession planning',
    category: 'Wealth planning topics',
  },
  {
    value: 'WEALTH_PLANNING_OTHERS',
    label: 'Wealth planning others',
    category: 'Wealth planning topics',
  },
  {
    value: 'PORTFOLIO_ANALYSIS_AND_PROPOSAL_DELIVERED',
    label: 'Portfolio analysis and proposal delivered',
    category: 'Investment topics',
  },
  {
    value: 'ACCESS_TO_SAFE_DEPOSIT_BOX',
    label: 'Access to safe deposit box',
    category: 'Other',
  },
  {
    value: 'CALL_BACK',
    label: 'Call back',
    category: 'Investment topics',
  },
  {
    value: 'INVESTMENT_PRODUCT_DELTA_NOTIFICATION_CLARIFICATION',
    label: 'Investment product delta notification clarification',
    category: 'Investment topics',
  },
  {
    value: 'MIFID_SUITABILITY',
    label: 'MiFID suitability',
    category: 'Investment topics',
  },
  {
    value: 'ACCOUNT_OPENING',
    label: 'Account opening',
    category: 'Client & account maintenance',
  },
  {
    value: 'ACCOUNT_MAINTENANCE',
    label: 'Account maintenance',
    category: 'Client & account maintenance',
  },
  {
    value: 'ACCOUNT_CLOSING',
    label: 'Account closing',
    category: 'Client & account maintenance',
  },
  {
    value: 'PERFORMANCE_REVIEW',
    label: 'Performance review',
    category: 'Investment topics',
  },
  {
    value: 'WEALTH_PLANNING_FINANCIAL_PLANNING',
    label: 'Wealth planning financial planning',
    category: 'Wealth planning topics',
  },
  {
    value: 'WEALTH_PLANNING_RELOCATION',
    label: 'Wealth planning relocation',
    category: 'Wealth planning topics',
  },
  {
    value: 'WEALTH_PLANNING_RETIREMENT',
    label: 'Wealth planning retirement',
    category: 'Wealth planning topics',
  },
  {
    value: 'WEALTH_PLANNING_STRUCTURING',
    label: 'Wealth planning structuring',
    category: 'Wealth planning topics',
  },
  {
    value: 'WEALTH_PLANNING_TAXATION',
    label: 'Wealth planning taxation',
    category: 'Wealth planning topics',
  },
  {
    value: 'PERFORMANCE',
    label: 'Performance',
    category: 'Investment topics',
  },
  {
    value: 'PERFORMANCE_REPORTING',
    label: 'Performance reporting',
    category: 'Investment topics',
  },
  {
    value: 'REPORTING',
    label: 'Reporting',
    category: 'Client & account maintenance',
  },
  {
    value: 'ADVICE_GIVEN',
    label: 'Advice given',
    category: 'Investment topics',
  },
  {
    value: 'ADVISORY',
    label: 'Advisory',
    category: 'Investment topics',
  },
  {
    value: 'ASSET_ALLOCATION',
    label: 'Asset allocation',
    category: 'Investment topics',
  },
  {
    value: 'CLIENT_CLASSIFICATION',
    label: 'Client classification',
    category: 'Investment topics',
  },
  {
    value: 'FINANCIAL_PROMOTION',
    label: 'Financial promotion',
    category: 'Investment topics',
  },
  {
    value: 'CAPTCHA',
    label: 'Captcha',
    category: 'Other',
  },
  {
    value: 'JB_OFFERING',
    label: 'JB offering',
    category: 'Other',
  },
];

export default topicOptions;
